import React from 'react';
import { Box, IconButton, useMediaQuery, useTheme as useMuiTheme } from '@mui/material';
import { Menu as MenuIcon } from 'lucide-react';
import { Logo } from './Logo';
import { NavbarCart } from './NavbarCart';
import { NAVBAR_HEIGHT, TOP_BANNER_HEIGHT } from './NavbarConstants';
import Searchbar from './Searchbar';
import { getHeaderStyles } from '../../../styles/headerStyles';
import { UserProfileMenu } from "./UserProfileMenu";
import { SafetyComponent } from "../../../components/security/SafetyComponent";
import { TiendaSecurityObjects } from "../../../types/security";
import { useTheme } from '../../../util/themes';


interface NavbarProps {
  isScrolled: boolean;
  cartCount: number;
  onMenuClick: () => void;
  onCartClick: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({
  isScrolled,
  cartCount,
  onMenuClick,
  onCartClick,
}) => {
  const appTheme = useTheme();
  const muiTheme = useMuiTheme();
  const isSmallScreen = useMediaQuery(muiTheme.breakpoints.down(900));
  const navbarHeight = isScrolled ? NAVBAR_HEIGHT.scrolled : NAVBAR_HEIGHT.normal;
  const totalHeaderHeight = TOP_BANNER_HEIGHT + navbarHeight;
  const headerStyles = getHeaderStyles(appTheme);

  return (
    <>
      <Box
        id="navbar"
        sx={{
          ...headerStyles.fixedHeader,
          justifyContent: "space-between",
          top: TOP_BANNER_HEIGHT,
          height: navbarHeight,
          transition: 'height 0.3s ease-in-out',
        }}
      >
        <Box 
          display="flex" 
          alignItems="center" 
          gap={2}
          flex={1}
          justifyContent="flex-start"
        >
          <IconButton
            onClick={onMenuClick}
            sx={{
              color: appTheme.colors.text.primary,
              '& svg': {
                color: appTheme.colors.text.primary,
                stroke: appTheme.colors.text.primary,
              },
            }}
          >
            <MenuIcon size={24} />
          </IconButton>
          {!isSmallScreen && (
            <Box sx={{ flex: 1 }}>
              <Searchbar />
            </Box>
          )}
        </Box>

        <Box 
          display="flex" 
          alignItems="center" 
          justifyContent="center" 
          flex={1}
        >
          <Logo isScrolled={isScrolled} />
        </Box>

        <Box 
          display="flex" 
          alignItems="center" 
          justifyContent="flex-end" 
          flex={1}
          gap={2.5}
        >

          <NavbarCart cartCount={cartCount} onClick={onCartClick} />

          <SafetyComponent objectCode={TiendaSecurityObjects.HeaderProfileButton} require="read">
            <UserProfileMenu />
          </SafetyComponent>

        </Box>
      </Box>
      <Box sx={{ height: totalHeaderHeight, minHeight: '0 !important' }} />
    </>
  );
}














